import React from "react";
import { StyleSheet, Image, View } from "react-native";

//Custom Imports
import color from "@constants/color";
import t from "@constants/localization";
import CustomText from "@components/CustomText";

const PATH = "screens/Contest/contestDetails";

const TipsBanner = ({ item = {} }) => {
  const { tips_banner = "" } = item;
  return (
    <View style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.titleText}
      >
        {t(`${PATH}/tips`)}
      </CustomText>
      <View style={styles.tipsBannerContainer}>
        <Image
          resizeMode={"contain"}
          style={styles.tipsBanner}
          source={{ uri: tips_banner }}
        />
      </View>
    </View>
  );
};

export default TipsBanner;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingHorizontal: 16,
    marginTop: 15,
  },
  titleText: {
    color: color.mediumBlack,
  },
  tipsBannerContainer: {
    marginTop: 4,
    borderRadius: 10,
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: 10,
    backgroundColor: color.white,
  },
  tipsBanner: {
    minHeight: 222,
  },
});
